import styles from './PartnerSplitPagesContainer.module.scss'
import { useSitewideMessage } from '@percent/cause-dashboard/common/hooks'
import { TitleAndPartner } from '@percent/cause-dashboard/common/components/titleAndPartner/TitleAndPartner'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Flex, Button, Grid } from '@percent/lemonade'
import { RoutePath } from '../../routes/Routes'
import { LocalePicker } from '@percent/cause-dashboard/common/components'

interface PartnerSplitPagesContainerProps {
  children: React.ReactNode
}

export const PartnerSplitPagesContainer = ({ children }: PartnerSplitPagesContainerProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { shouldShowSitewideMessage } = useSitewideMessage()
  const shiftDownToAccomodateRebrandNotification = shouldShowSitewideMessage ? 48 : 0
  const minHeightToAccomodateRebrandNotification = shouldShowSitewideMessage ? 'calc(100vh - 48px)' : '100vh'

  return (
    <Grid
      className={styles.container}
      style={{
        marginTop: shiftDownToAccomodateRebrandNotification,
        minHeight: minHeightToAccomodateRebrandNotification
      }}
    >
      <Grid.Col span={{ sm: 12, md: 5 }} className={styles.leftScreen}>
        <TitleAndPartner />
      </Grid.Col>
      <Grid.Col span={{ sm: 12, md: 7 }} className={styles.rightScreen}>
        <Flex className={styles.signInBtnCtn}>
          <Button variant="secondary" onClick={() => navigate(RoutePath.SIGNIN)} data-testId="signInBtn">
            {t('button.logIn')}
          </Button>
          <LocalePicker />
        </Flex>
        <Flex justify="center">{children}</Flex>
      </Grid.Col>
    </Grid>
  )
}
